import { SubmitFormEntry } from '@chilipiper/api-client/src/chat-platform-chat'
import { PublicLocalizationEntry } from '@chilipiper/api-client/src/customization-settings'
import { DEFAULT_LOCALE } from '@chilipiper/locale/src/new'
import { isDefined } from '@chilipiper/utils'

type Props = {
  dataFields: SubmitFormEntry[]
  locale?: string
  translations?: PublicLocalizationEntry[]
}

export const mapFormFields = ({
  locale = DEFAULT_LOCALE,
  translations = [],
  dataFields,
}: Props) => {
  if (!dataFields) {
    return []
  }
  return dataFields
    .map(dataField => mapDataFieldToForm(dataField, locale, translations))
    .filter(isDefined)
}

const mapDataFieldToForm = (
  dataField: SubmitFormEntry,
  locale: string,
  translations: PublicLocalizationEntry[]
) => {
  const translatedFormField = getTranslationsFromField(dataField.ref, locale, translations)
  return {
    ...dataField,
    translations: translatedFormField,
  }
}

const getTranslationsFromField = (
  fieldId: string,
  locale: string,
  translations: PublicLocalizationEntry[]
) => {
  const translatedError = translations?.find(
    translation =>
      translation.locale === locale &&
      translation.key.key === fieldId &&
      translation.key.subKey === 'errorMessage'
  )?.value

  // This translation comes from DF section while field.localizations comes from meeting types
  const translatedLabel = translations?.find(
    translation =>
      translation.locale === locale &&
      translation.key.key === fieldId &&
      translation.key.subKey === 'Label'
  )?.value
  return {
    error: translatedError,
    label: translatedLabel,
  }
}
